import React from "react";
import classes from "./GetInTouch.module.scss";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";
import ArrowWithTail from "../../assets/icons/ArrowWithTail";

type Props = {
  btnText?: string;
  btnClickHandler?: () => void;
};

function GetInTouch(props: Props) {
  const { btnClickHandler = () => navigate("/contact-us") } = props;

  const navigate = useNavigate();

  return (
    <div className={classes["container"]}>
      <img
        src="https://se-website-image.s3.ap-south-1.amazonaws.com/wind-farm.jpeg"
        alt="wind-farm"
        className={classes["wind-farm-img"]}
      />

      <div className={classes["right-card"]}>
        <div className={classes["details"]}>
          <p>
            Are you <br /> ready to drive the <br /> future of{" "}
            <span>
              clean
              <br />
              energy
            </span>{" "}
            with <span>AI</span>?
          </p>
        </div>

        <Button
          className={classes.btn}
          text={
            <>
              Get in touch <ArrowWithTail width={14} height={10} color="#fff" />
            </>
          }
          btnClickHandler={btnClickHandler}
        />
      </div>
    </div>
  );
}

export default GetInTouch;
